import { z } from 'zod';
import { PointSchema } from './Point.schema';

export const DiagramInfoBlockSchema = z.object({
    id: z.string(),
    position: PointSchema,
    dimensions: z
        .object({
            width: z.number().default(0),
            height: z.number().default(0),
        })
        .default({}),
    blocks: z
        .union([
            z.object({
                id: z.string().optional(),
                blockType: z.literal('text'),
                label: z.string().default(''),
                value: z.string().default(''),
            }),
            z.object({
                id: z.string().optional(),
                blockType: z.literal('textarea'),
                label: z.string().default(''),
                value: z.string().default(''),
            }),
            z.object({
                id: z.string().optional(),
                blockType: z.literal('lastUpdated'),
                label: z.string().default(''),
            }),
            z.object({
                id: z.string().optional(),
                blockType: z.literal('images'),
                images: z.string().array().default([]),
                imageSize: z.enum(['full', '1/2', '1/3', '1/4']).default('1/3'),
            }),
            z.object({
                id: z.string().optional(),
                blockType: z.literal('spacer'),
            }),
            z.object({
                id: z.string().optional(),
                blockType: z.literal('divider'),
            }),
        ])
        .array()
        .default([]),
});
